import { render } from "./CouponStatus.vue?vue&type=template&id=51204f9a&ts=true"
import script from "./CouponStatus.vue?vue&type=script&lang=ts"
export * from "./CouponStatus.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__